import  jwt from "jwt-decode";
import { User } from "../types/orders/user";
import { AUTH_BASE_URL } from "../redux/actions/dashboard/env.variables";

export const ROLE_TYPE_DISTRIBUIDOR_ANALISTA = "DistribuidorAnalista";
export const ROLE_TYPE_DISTRIBUIDOR_ADMINISTRADOR = "DistribuidorAdministrador";
class AuthService {
    readonly loginUrl = AUTH_BASE_URL + '/Account/Login?returnUrl=' +encodeURIComponent(window.location.href);
    readonly logoutUrl = AUTH_BASE_URL + '/Account/logout';

    login (token:string, refreshToken: string): User | null {
        try 
        {
            const jwtUser: any = jwt(token); // decode your token here
            if (jwtUser) {
    
                let user =  {
                    organizationCode: jwtUser.OrganizationCode,
                    userCode: jwtUser.UserCode,
                    type: jwtUser['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
                    token:  token,
                    name: jwtUser['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
                    refreshToken: refreshToken,
                    expiration: jwtUser.exp, 
                } as User;
    
                localStorage.setItem("user", JSON.stringify(user));
    
                return user;
            }
        }
        catch(ex){
            return null;
        }       
        return null;
    }

    logout(callback: () => void) {
        localStorage.removeItem("user");
        callback();
    }


}

export default new AuthService();
